module.exports = __webpack_public_path__ + "img/icon_03.23b9346.png";